module.exports = __webpack_public_path__ + "static/media/gro_flo_acc_egr.98bb28c4.png";